import { render } from "./ClientsSection.vue?vue&type=template&id=3ec60292"
import script from "./ClientsSection.vue?vue&type=script&lang=js"
export * from "./ClientsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__